export type NotificationCategory =
  | 'operational'
  | 'platform_health'
  | 'analytics'
  | 'billing';

/**
 * Display-only labels for notification categories. These are purely a
 * frontend mapping — the raw values above are what we send to and receive
 * from the API; only the text shown in the console differs.
 */
const NOTIFICATION_CATEGORY_LABELS: Record<NotificationCategory, string> = {
  operational: 'Configuration',
  platform_health: 'Health',
  analytics: 'Analytics',
  billing: 'Billing',
};

export function getNotificationCategoryLabel(category: string): string {
  return (
    NOTIFICATION_CATEGORY_LABELS[category as NotificationCategory] ??
    category.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export type NotificationType =
  | 'gateway_offline'
  | 'gateway_removed'
  | 'camera_offline'
  | 'camera_flapping'
  | 'deployment_stalled'
  | 'cpu_usage'
  | 'gpu_usage'
  | 'memory_usage'
  | 'stream_quality_low'
  | 'event_ingestion_delay'
  | 'multiple_cameras_offline'
  | 'camera_added'
  | 'camera_removed'
  | 'stream_added'
  | 'stream_removed'
  | 'gateway_added'
  | 'workflow_deployed'
  | 'user_added'
  | 'workflow_config_changed'
  | 'user_role_changed'
  | 'gateway_firmware_updated'
  | 'analytics_event';

export type NotificationFrequency = 'immediate' | 'digest_hourly' | 'digest_daily';

export type EntityFilterSet = {
  gateway_ids?: string[];
  camera_ids?: string[];
  stream_ids?: string[];
  deployment_ids?: string[];
  pipeline_ids?: string[];
  tag_ids?: string[];
};

export type EntityFilters = {
  include?: EntityFilterSet | null;
  exclude?: EntityFilterSet | null;
};

export type NotificationRule = {
  id: string;
  application_id: string;
  name: string;
  enabled: boolean;
  notification_categories: NotificationCategory[];
  notification_types: NotificationType[] | null;
  entity_filters: EntityFilters | null;
  title_keywords: string[];
  user_group_ids: string[];
  frequency: NotificationFrequency;
  created_by: string | null;
  created_at: string;
  updated_at: string;
};

export type NotificationTypeInfo = {
  value: NotificationType;
  categories: NotificationCategory[];
};
